export const BOUTIQUE_FLAG_PRODUCTS = 'flag_products';
export const BOUTIQUE_SHORTLIST = 'shortlist';
export const BOUTIQUE_REDIRECT_URL = 'redirect_url';
